var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',{staticClass:"w-3 h-3 circle rounded-full absolute bg-red-600"}),_c('span',{staticClass:"w-4 h-4 ring rounded-full absolute border-3 border-red-600"})])
}]

export { render, staticRenderFns }